/**
* @summary - Component that Provides Facility Details Tab
* @author Yuvasri S
* @since 2024-07-04
*/
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Button, TextField, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Typography } from '@mui/material';
import TabContentLayout from './TabContentLayout';
import CustomTextField from '../commoncomponents/CustomTextField';
import { getAuthToken, getcompanyId, getCreatedBy } from "../../utility/tokenUtility";
import { MasterGraph } from '../../utility/apiURLS';
import axios from "axios";
import { updateFacilityDetails } from '../../redux/reducers/HospitalInformationReducer/formSlice';
import { BreadcrumbBar } from '../../assets/styled-components/breadcrumbBar';
import HomeIconButton from '../commoncomponents/HomeIconButton';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { DefaultCard } from '../../assets/styled-components/card';
import { useNavigate } from "react-router";
import CustomDialog from '../commoncomponents/CustomDialog';
import { updateHospitalInformation, setMasfacilitydetailsId } from '../../redux/reducers/HospitalInformationReducer/formSlice'; // Import setMashospitaldetailsId
import CustomTextArea from '../commoncomponents/CustomTextArea';


const services = ["FMS", "BEMS", "FEMS"];

function FacilityDetailsContent({ hospitalcode, hospitalname, hospitalInformation, facilityDetails, onUpdateFacilityDetails, isViewMode, isEditMode }) {
    const dispatch = useDispatch();
    const hospitalDetailsId = useSelector((state) => state.form.mashospitaldetailsId);
    const [isUpdate, setIsUpdate] = useState(false);
    const [primaryId, setPrimaryId] = useState('')
    const { fmshos1, fmshos2, bemshos1, bemshos2, femshos1, femshos2, fmslo1,
        fmslo2, bemslo1, bemslo2, femslo1, femslo2, speciality, facilitiesoutside, nonhospitalfacilities
    } = facilityDetails
    const {
        id,
    } = hospitalInformation;

    const [dialogOpen, setDialogOpen] = useState(false);
    const token = getAuthToken("id_token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const companyId = getcompanyId('companyId');
    const createdBy = getCreatedBy('createdBy');
    const navigate = useNavigate();
    const [successDialogOpen, setSuccessDialogOpen] = useState(false);
    const [succesDialogMessage, setSuccessDialogMessage] = useState('');
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const firstEditableFieldRef = useRef(null);

    useEffect(() => {
        if (firstEditableFieldRef.current) {
            firstEditableFieldRef.current.focus();
        }
    }, []);

    const fetchFacilityDetails = async () => {
        if (!hospitalDetailsId) return;
        try {
            const response = await axios.get(`${MasterGraph}/api/GraphHospitalMaster/GetMashospitalfacilitydetailsAsyncFetch/${hospitalDetailsId}`, config);

            // Check if response data is valid and contains expected data
            if (response.data && response.data.length > 0) {
                const facilityDetails = response.data[0];
                // Update the state with the fetched details
                onUpdateFacilityDetails({
                    fmshos1: facilityDetails.headoffms,
                    fmshos2: facilityDetails.headoffms1,
                    bemshos1: facilityDetails.headofbems,
                    bemshos2: facilityDetails.headofbems1,
                    femshos1: facilityDetails.headoffems,
                    femshos2: facilityDetails.headoffems1,
                    fmslo1: facilityDetails.liaisonofficerfms,
                    fmslo2: facilityDetails.liaisonofficerfms1,
                    bemslo1: facilityDetails.liaisonofficerbems,
                    bemslo2: facilityDetails.liaisonofficerbems1,
                    femslo1: facilityDetails.liaisonofficerfems,
                    femslo2: facilityDetails.liaisonofficerfems1,
                    speciality: facilityDetails.speciality,
                    facilitiesoutside: facilityDetails.facilitiesoutside,
                    nonhospitalfacilities: facilityDetails.nonhospitalfacilities
                });

                setIsUpdate(true);
                setPrimaryId(facilityDetails.id);

            } else {
                console.error("No facility details found for the given hospital details ID");
                setDialogOpen(true);
                // Handle the case where no facility details are found
                onUpdateFacilityDetails({
                    fmshos1: '',
                    fmshos2: '',
                    bemshos1: '',
                    bemshos2: '',
                    femshos1: '',
                    femshos2: '',
                    fmslo1: '',
                    fmslo2: '',
                    bemslo1: '',
                    bemslo2: '',
                    femslo1: '',
                    femslo2: '',
                    speciality: '',
                    facilitiesoutside: '',
                    nonhospitalfacilities: ''
                });
                setPrimaryId('');
            }
        } catch (error) {
            console.error("Error fetching facility details:", error);
            onUpdateFacilityDetails({
                fmshos1: '',
                fmshos2: '',
                bemshos1: '',
                bemshos2: '',
                femshos1: '',
                femshos2: '',
                fmslo1: '',
                fmslo2: '',
                bemslo1: '',
                bemslo2: '',
                femslo1: '',
                femslo2: '',
                speciality: '',
                facilitiesoutside: '',
                nonhospitalfacilities: ''
            });
        }
    };

    const handleChange = (field, newValue) => {
        setHasUnsavedChanges(true); // Flagging that there are unsaved changes
        onUpdateFacilityDetails({ [field]: newValue });
        switch (field) {
            case 'fmshos1':
                dispatch(updateFacilityDetails({ fmshos1: newValue }));
                break;

            case 'fmshos2':
                dispatch(updateFacilityDetails({ fmshos2: newValue }));
                break;
            case 'bemshos1':
                dispatch(updateFacilityDetails({ bemshos1: newValue }));
                break;
            case 'bemshos2':
                dispatch(updateFacilityDetails({ bemshos2: newValue }));
                break;
            case 'femshos1':
                dispatch(updateFacilityDetails({ femshos1: newValue }));
                break;
            case 'femshos2':
                dispatch(updateFacilityDetails({ femshos2: newValue }));
                break;
            case 'fmslo1':
                dispatch(updateFacilityDetails({ fmslo1: newValue }));
                break;
            case 'fmslo2':
                dispatch(updateFacilityDetails({ fmslo2: newValue }));
                break;
            case 'bemslo1':
                dispatch(updateFacilityDetails({ bemslo1: newValue }));
                break;
            case 'bemslo2':
                dispatch(updateFacilityDetails({ bemslo2: newValue }));
                break;
            case 'femslo1':
                dispatch(updateFacilityDetails({ femslo1: newValue }));
                break;
            case 'femslo2':
                dispatch(updateFacilityDetails({ femslo2: newValue }));
                break;
            case 'speciality':
            case 'facilitiesoutside':
            case 'nonhospitalfacilities':
                // For CustomTextField components, newValue is directly the string value
                switch (field) {
                    case 'speciality':
                        dispatch(updateFacilityDetails({ speciality: newValue }));
                        break;
                    case 'facilitiesoutside':
                        dispatch(updateFacilityDetails({ facilitiesoutside: newValue }));
                        break;
                    case 'nonhospitalfacilities':
                        dispatch(updateFacilityDetails({ nonhospitalfacilities: newValue }));
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (hospitalDetailsId) {
            fetchFacilityDetails();
        }
    }, [hospitalDetailsId]);

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleDialogConfirm = () => {
        setDialogOpen(false);
    };

    const handleSave = async () => {
        try {



            if (primaryId) {
                const payload = {
                    createdby: createdBy,
                    headoffems: femshos1,
                    headofbems: bemshos1,
                    headoffms: fmshos1,
                    liaisonofficerfems: femslo1,
                    liaisonofficerbems: bemslo1,
                    liaisonofficerfms: fmslo1,
                    headoffems1: femshos2,
                    headofbems1: bemshos2,
                    headoffms1: fmshos2,
                    liaisonofficerfems1: femslo2,
                    liaisonofficerbems1: bemslo2,
                    liaisonofficerfms1: fmslo2,
                    speciality: speciality,
                    facilitiesoutside: facilitiesoutside,
                    nonhospitalfacilities: nonhospitalfacilities,
                    id: primaryId
                };
                const putUrl = `${MasterGraph}/api/mashospitalfacilitydetails/${primaryId}`;
                await axios.put(putUrl, payload, config);
                setSuccessDialogMessage('Data updated successfully.');
            } else {
                const payload = {
                    createdby: createdBy,
                    headoffems: femshos1,
                    headofbems: bemshos1,
                    headoffms: fmshos1,
                    liaisonofficerfems: femslo1,
                    liaisonofficerbems: bemslo1,
                    liaisonofficerfms: fmslo1,
                    headoffems1: femshos2,
                    headofbems1: bemshos2,
                    headoffms1: fmshos2,
                    liaisonofficerfems1: femslo2,
                    liaisonofficerbems1: bemslo2,
                    liaisonofficerfms1: fmslo2,
                    speciality: speciality,
                    facilitiesoutside: facilitiesoutside,
                    nonhospitalfacilities: nonhospitalfacilities,
                    mashospitaldetails: {
                        id: hospitalDetailsId,
                        hospitalname: hospitalname
                    }
                };
                const response = await axios.post(`${MasterGraph}/api/mashospitalfacilitydetails`, payload, config);
                const savedDataId = response.data.id;
                setPrimaryId(savedDataId); // Set the primaryId to the ID received from POST response
                setSuccessDialogMessage('Data saved successfully.');
            }
            setHasUnsavedChanges(false);
            setSuccessDialogOpen(true);
        } catch (error) {
            console.error("Error saving Facility details:", error);
        }
    };
    const handleCancel = () => {
        if (hasUnsavedChanges && !isViewMode) {
            setCancelDialogOpen(true);
        } else {
            navigate(-1, { replace: true });
        }
    };

    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };

    const handleCancelDialogConfirm = () => {
        setCancelDialogOpen(false);
        navigate(-1, { replace: true });
    };


    return (
        <TabContentLayout>
            <DefaultCard sx={{ height: '100%' }}>
                <form onSubmit={(newValue) => newValue.preventDefault()} style={{ position: 'relative' }}>
                    <Box mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <CustomTextField
                                    label="Hospital Code"
                                    id="hospital-code"
                                    value={hospitalcode}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CustomTextField
                                    maxlength={225}
                                    label="Hospital Name"
                                    id="hospital-name"
                                    value={hospitalname}
                                    disabled
                                />
                            </Grid>
                        </Grid>
                        <Table sx={{ mt: 2 }} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ width: '5%', fontWeight: 'bold' }}>S.No</TableCell>
                                    <TableCell sx={{ width: '5%', fontWeight: 'bold' }}>Service</TableCell>
                                    <TableCell sx={{ width: '35%', fontWeight: 'bold' }}>Head of Service</TableCell>
                                    <TableCell sx={{ width: '35%', fontWeight: 'bold' }}>Liaison Officer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {services.map((service, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell sx={{ width: '10%' }}>
                                            <CustomTextField
                                                id="service"
                                                value={service}
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{ width: '80px' }} // Adjust width here as needed
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <CustomTextField
                                                    value={
                                                        service === "FMS" ? fmshos1 :
                                                            service === "BEMS" ? bemshos1 : femshos1
                                                    }
                                                    onChange={(newValue) =>
                                                        handleChange(
                                                            service === "FMS" ? 'fmshos1' :
                                                                service === "BEMS" ? 'bemshos1' : 'femshos1',
                                                            newValue
                                                        )
                                                    }
                                                    id="hos"
                                                    fullWidth
                                                    size="small"
                                                    disabled={isViewMode}
                                                    maxlength={60}
                                                    inputRef={index === 0 ? firstEditableFieldRef : null} // Set ref for the first field

                                                />
                                                <CustomTextField
                                                    value={
                                                        service === "FMS" ? fmshos2 :
                                                            service === "BEMS" ? bemshos2 : femshos2
                                                    }
                                                    onChange={(newValue) =>
                                                        handleChange(
                                                            service === "FMS" ? 'fmshos2' :
                                                                service === "BEMS" ? 'bemshos2' : 'femshos2',
                                                            newValue
                                                        )
                                                    }
                                                    id="hos2"
                                                    size="small"
                                                    sx={{ mt: 1 }}
                                                    disabled={isViewMode}
                                                    maxlength={60}
                                                />
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <CustomTextField
                                                    value={
                                                        service === "FMS" ? fmslo1 :
                                                            service === "BEMS" ? bemslo1 : femslo1
                                                    }
                                                    onChange={(newValue) =>
                                                        handleChange(
                                                            service === "FMS" ? 'fmslo1' :
                                                                service === "BEMS" ? 'bemslo1' : 'femslo1',
                                                            newValue
                                                        )
                                                    }
                                                    id="lo1"
                                                    fullWidth
                                                    size="small"
                                                    disabled={isViewMode}
                                                    maxlength={60}
                                                />
                                                <CustomTextField
                                                    value={
                                                        service === "FMS" ? fmslo2 :
                                                            service === "BEMS" ? bemslo2 : femslo2
                                                    }
                                                    onChange={(newValue) =>
                                                        handleChange(
                                                            service === "FMS" ? 'fmslo2' :
                                                                service === "BEMS" ? 'bemslo2' : 'femslo2',
                                                            newValue
                                                        )
                                                    }
                                                    id="lo2"
                                                    fullWidth
                                                    size="small"
                                                    sx={{ mt: 1 }}
                                                    disabled={isViewMode}
                                                    maxlength={60}
                                                />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <Grid container spacing={2} mt={2}>
                            <Grid item xs={12} sm={4}>
                                <CustomTextArea
                                    label="Speciality"
                                    id="speciality"
                                    value={speciality}
                                    onChange={(newValue) => handleChange('speciality', newValue)}
                                    disabled={isViewMode}
                                    maxlength={255}
                                />
                                {/* <CustomTextField
                                    maxlength={255}
                                    label="Speciality"
                                    id="speciality"
                                    value={speciality}
                                    onChange={(newValue) => handleChange('speciality', newValue)}
                                    disabled={isViewMode}
                                /> */}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CustomTextArea
                                    maxlength={255}
                                    label="Facilities outside"
                                    id="facilities-outside"
                                    value={facilitiesoutside}
                                    onChange={(newValue) => handleChange('facilitiesoutside', newValue)}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CustomTextArea
                                    maxlength={255}
                                    label="Non Hospital Facilities"
                                    id="non-hospital-facilities"
                                    value={nonhospitalfacilities}
                                    onChange={(newValue) => handleChange('nonhospitalfacilities', newValue)}
                                    disabled={isViewMode}
                                />

                            </Grid>
                        </Grid>
                    </Box>
                </form>
            </DefaultCard>
            <CustomDialog
                open={dialogOpen}
                onClose={handleDialogClose}
                title="Error"
                content="No Facility Details found"
                confirmBtn="OK"
                onConfirm={handleDialogConfirm}
            />
            <CustomDialog
                open={successDialogOpen}
                onClose={() => setSuccessDialogOpen(false)}
                content={succesDialogMessage}
                confirmBtn="OK"
                onConfirm={() => setSuccessDialogOpen(false)}
            />
            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                title="Unsaved Changes"
                content="Record(s) not Saved/Updated. Do you want to continue?"
                confirmBtn="Yes"
                cancelBtn="No"
                onConfirm={handleCancelDialogConfirm}
                onCancel={handleCancelDialogClose}
            />
            {isViewMode ? (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
                        Back
                    </Button>
                </Box>

            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant="contained" color="primary" sx={{ m: 1 }} onClick={handleSave}>
                        Save
                    </Button>
                    <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
                        Back
                    </Button>
                </Box>
            )}
        </TabContentLayout>
    );
}

export default FacilityDetailsContent;
